import styled from '@emotion/styled';
import { createMediaQuery, token } from '@ferreri/prever-component-lib';

export const CategoriesListScrollContainer = styled.div`
  gap: ${token.spacing.spacingSmall};
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow-x: scroll;

  /* Hide scrollbar */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }

  padding: ${token.spacing.spacingSmall} ${token.spacing.spacingSmall};
  margin: -${token.spacing.spacingSmall} 0;

  max-width: 1440px;
  margin: 0 auto;

  ${createMediaQuery({
    desktop: {
      overflow: 'unset',
      flexWrap: 'wrap',
      padding: `0 ${token.spacing.spacingXxLarge}`,
    },
  })};
`;
